import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import clsx from 'clsx';
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import styles from './JobDetailsOverviewButton.module.scss';
import { JobDetailsOverviewButtonProps } from './types';

const JobDetailsOverviewButton = ({ url }: JobDetailsOverviewButtonProps) => {
  const isMobile = useIsMobile(BreakPoint.MD);

  return (
    <Link className={styles.base} to={url}>
      <Icon size="iconSize24" variant="action/arrow-left" />
      <span className={clsx({ 'visually-hidden': isMobile })}>Übersicht</span>
    </Link>
  );
};

export default JobDetailsOverviewButton;
